import { Col } from "react-bootstrap";
import { UrlInput } from "./urlInput";
/* <script src="https://scripts.sirv.com/sirvjs/v3/sirv.js"></script> */
export const ProjectCard = ({ imgUrl, title, tools, projectUrl, description }) => {
  return (

    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        {/* <img class="Sirv image-main" src={imgUrlbg} alt="imgUrlbg" />
        <img class="Sirv image-hover" src={imgUrl} alt="imgUrl" /> */}
        <img src={imgUrl} alt="imgUrl" />
        <div className="proj-txtx">
          <h4>
            {title}
            <div className="proj-tools">({tools})</div>
          </h4>
          <span>{description}</span>
          <br></br>
          <UrlInput url={projectUrl} />
        </div>
      </div>
    </Col>
  )
}

